/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {
  // $(".product-form").submit((e) => {
  //   // e.preventDefault()
  //   let flg = false;
  //   $(".spb-select .custom").each((index, element) => {
  //     let selectVal = $(element).val();
  //     if (selectVal === "") {
  //       $(element).next(".spb-error").show();
  //       flg = true;
  //     }
  //   });
  //   if (flg) e.preventDefault();
  // });
console.log("READY")
  var form = document.getElementsByClassName('product-form')[0]; // form has to have ID: <form id="formID">
  form.noValidate = true;
  form.addEventListener('submit', function(event) { // listen for form submitting
      if (!event.target.checkValidity()) {
         event.preventDefault(); // dismiss the default functionality
         alert('Please, select the options'); // error message
      }
  }, false);

  $(".spb-select .custom").on("change", function () {
    $(this).next(".spb-error").hide();
  });

  $("#infiniteoptions-container").on("DOMSubtreeModified", function () {
    let variant_names=$("#variant_names_hide_monogram_options").val().replace(/['"]+/g, '').replace(/\s/g, '').trim().toLowerCase().split(",");
    if ($("#is_hide_all_monogram_options").val() === "true") {
      $("option[value^='Monogram']").remove();
    }else if(variant_names[0]!==''){
      // console.log(variant_names)
      let current_selected_variant=$(".product-form__selected-value").text().replace(/['"]+/g, '').replace(/\s/g, '').trim().toLowerCase();
      if(variant_names.indexOf(current_selected_variant)!==-1){
        $("option[value^='Monogram']").hide();
      }
      $(".block-swatch").click(function () {
        // console.log($(this).find(".block-swatch__item-text").text().replace(/['"]+/g, '').trim().toLowerCase())
        let block_val=$(this).find(".block-swatch__item-text").text().replace(/['"]+/g, '').replace(/\s/g, '').trim().toLowerCase();
          if(variant_names.indexOf(block_val)!==-1){
            $("option[value^='Monogram']").hide();
          }else{
            $("option[value^='Monogram']").show();
          }
          
      })
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
    const toggles = document.querySelectorAll('.seo-text__read-more-link');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        const wrapper = e.target.closest('.seo-text-wrapper');
        const text = wrapper.querySelector('.seo-text');

        text.classList.toggle('expanded');
        toggle.textContent = text.classList.contains('expanded') ? 'Read less' : 'Read more';
      });
    });
  });

class DimensionConfirmation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.requestAnimationFrame(()=>{
      // const productSection = document.querySelector("[data-section-type='product']");
      const heightInput = this.querySelector("#grill-height");
      const lengthInput = this.querySelector("#grill-length");

      const toggleButtonState = () => {
        console.log("heightInput.value", heightInput.value);
        const addToCartBtn = document.querySelector('form[action^="/cart/add"] button[type="submit"]');
        if (heightInput.value.trim() && lengthInput.value.trim()) {
          addToCartBtn.removeAttribute("disabled");
          addToCartBtn.classList.remove("button--disabled");
        } else {
          addToCartBtn.setAttribute("disabled", "disabled");
          addToCartBtn.classList.add("button--disabled");
        }
      };

      heightInput.addEventListener("input", toggleButtonState);
      lengthInput.addEventListener("input", toggleButtonState);
      document.addEventListener('variant:changed', function(event) {
        var variant = event.detail.variant;
        toggleButtonState();
      });

      // Disable button on initial load
      toggleButtonState();
    });
    }
  }
  customElements.define("dimension-confirmation", DimensionConfirmation);
